import React from 'react';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hi, I have an enquiry to make.");
    const whatsappUrl = `https://wa.me/9251110346?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="whatsapp-float">
      <button 
        className="whatsapp-btn" 
        onClick={handleWhatsAppClick}
        aria-label="Chat on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
        <span className="whatsapp-text">WhatsApp</span>
      </button>
    </div>
  );
};

export default WhatsAppFloat;